import { render, staticRenderFns } from "./AddressRentCreateUpdate.vue?vue&type=template&id=87d9f4ae&scoped=true&"
import script from "./AddressRentCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./AddressRentCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./AddressRentCreateUpdate.vue?vue&type=style&index=0&id=87d9f4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d9f4ae",
  null
  
)

export default component.exports